/**
 * Funções auxiliares para o módulo Formulário Simples
 */

export function escapeHtml(text) {
    if (text === null || text === undefined) return '';
    const div = document.createElement('div');
    div.textContent = String(text);
    return div.innerHTML;
}

export function normalizeFormularioSimplesData(data = {}) {
    const selectOptions = normalizeSelectOptions(
        data.selectOptions ||
        data.select_options ||
        data.opcoes_select ||
        data.options ||
        []
    );

    return {
        title: data.title || data.titulo || 'Receba novidades por e-mail',
        description: data.description || data.descricao || '',
        ctaText: data.ctaText || data.cta_text || data.cta || 'Continuar',
        namePlaceholder: data.namePlaceholder || data.name_placeholder || 'Nome completo',
        emailPlaceholder: data.emailPlaceholder || data.email_placeholder || 'Digite seu e-mail',
        selectPlaceholder: data.selectPlaceholder || data.select_placeholder || 'Selecione uma opção',
        selectLabel: data.selectLabel || data.select_label || '',
        selectName: data.selectName || data.select_name || 'interesse',
        nameRequiredMessage: data.nameRequiredMessage || 'Nome completo é obrigatório.',
        nameInvalidMessage: data.nameInvalidMessage || 'Preencha nome e sobrenome.',
        emailRequiredMessage: data.emailRequiredMessage || 'E-mail é obrigatório.',
        emailInvalidMessage: data.emailInvalidMessage || 'E-mail inválido.',
        selectRequiredMessage: data.selectRequiredMessage || 'Selecione uma opção.',
        successMessage: data.successMessage || 'Cadastro realizado com sucesso!',
        selectOptions,
        raw: data
    };
}

function normalizeSelectOptions(options) {
    if (!Array.isArray(options)) return [];

    return options
        .map((option) => {
            if (typeof option === 'string') {
                return { label: option, value: option };
            }

            if (option && typeof option === 'object') {
                const label = option.label || option.nome || option.nome_campanha || option.text || '';
                const value = option.value || option.valor || option.idcampaing || label;
                if (!label || !value) return null;
                return {
                    label,
                    value,
                    campaignIdentifier: option.campaignIdentifier || option.idcampaing || value,
                    categoria: option.categoria || option.nome_campanha || label,
                    slug: option.slug || ''
                };
            }

            return null;
        })
        .filter(Boolean);
}
